import { IoChevronBack, IoClose } from "react-icons/io5";
import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Analytics,Gtag } from '../compornents/Analytics';

export const Options = () => {
  const navigate = useNavigate();
  let location = useLocation();
  let data = location.state?.data || {item:{},quote:{},options:[]};
  let option_category = location.state?.option_category || [];

  // 戻る
  const back = () => {
    navigate("/option_category", { state: { data:data } });
  };

  // ホームへ
  const toHome = () => {
    navigate("/home");
  };

  // オプションカテゴリ選択
  function selectOption(option) {
    navigate("/option", { state: { data:data,option_category:option_category,option:option } });
  };


  useEffect(() => {
    // ページトップ
    setTimeout(() => {
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      window.scrollTo(0, 0); // 念のため併用
    }, 10);
    Gtag('view_options');
    if (location.state === null || location.state.data === undefined) {
      navigate("/home");
    }
  }, [location, navigate]);

  // 2列カード（グリッド）。画像は正方形でカード幅いっぱい。未登録はプレースホルダ。
  const cardImage = (src) => (
    src
      ? <img src={src} alt="" style={{ width: '100%', aspectRatio: '1 / 1', objectFit: 'cover', display: 'block', background: '#fafafa' }} />
      : <div style={{ width: '100%', aspectRatio: '1 / 1', background: '#f1f3f5', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 34 }}>✨</div>
  );

  const listOptions = option_category?.options?.length > 0 ? (
    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
      {option_category.options.map((option, index) => (
        <div
          className="div_btn"
          onClick={() => selectOption(option)}
          key={index}
          style={{ border: '1px solid #ececec', borderRadius: 14, overflow: 'hidden', background: '#fff', boxShadow: '0 1px 3px rgba(0,0,0,.06)' }}
        >
          {cardImage(Number(option.is_not_picture) !== 1 ? option.img : '')}
          <div style={{ padding: '8px 10px 10px' }}>
            <div style={{ fontWeight: 600, fontSize: 14, lineHeight: 1.35 }}>{option.name}</div>
            {Number(option.kin2) > 0 && (
              <div style={{ color: '#555', marginTop: 4 }}>
                <small>1点 ¥{Number(option.kin2).toLocaleString()}<span style={{ color: '#999' }}>（税込）</span></small>
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  ) : (<div>オプションはありません</div>);
  return (
    <div className="App">
      <div className="Confirm">
        <Analytics title={option_category?.name || 'オプション'} />
        <div className="toolbar">
          <div className="toolbar_left">
            <div className="">
              <IoChevronBack onClick={back} />
            </div>
          </div>
          <div className="toolbar_center">
            {option_category?.name}
          </div>
          <div className="toolbar_right">
            <IoClose onClick={toHome} />
          </div>
        </div>
        <div className="mb-2 border-bottom"></div>
        <div className="content">
          {listOptions}
        </div>
      </div>

    </div>
  );
}
